import { type Pagination } from '@on3/api';
import { useRouter } from 'next/router';

import styles from './Simple.module.scss';

export const SimplePagination = ({
  data,
}: {
  data: Pagination | undefined;
}) => {
  const router = useRouter();
  const { currentPage = 1, pageCount = 1 } = data || {};

  function handleNext() {
    router.push({
      query: { ...router.query, page: currentPage + 1 },
    });
  }

  function handlePrevious() {
    router.push({
      query: { ...router.query, page: currentPage - 1 },
    });
  }

  if (pageCount < 2) return null;

  return (
    <nav className={styles.block} data-ui="pagination">
      <span>
        {currentPage} of {pageCount}
      </span>
      <button
        disabled={currentPage === 1}
        onClick={handlePrevious}
        type="button"
      >
        Previous
      </button>
      <button
        disabled={currentPage === pageCount}
        onClick={handleNext}
        type="button"
      >
        Next
      </button>
    </nav>
  );
};
